@if (appointmentInfo.listing) {
<gallery-listing-card class="la-card" [listing]="appointmentInfo.listing" [canSelect]="false" [isShortCard]="true"
    [hideOpenRentals]="shouldHideOpenRentals" [companyConfiguration]="companyConfiguration"
    (listingDetailsClicked)="onAppointmentCardClicked()" (mediaViewerClicked)="onMediaViewerClicked($event)"
    (priceChangeClicked)="onAppointmentCardClicked()">

    <ng-template #bodyExtraFooter>

        <div class="la-card-footer" (click)="$event.stopPropagation(); onAppointmentCardClicked()">

            <div class="la-card-footer-block">

                <div class="la-card-footer-icon-wrap">

                    <rpc-icon class="la-card-footer-icon" [iconName]="'appointment'">
                    </rpc-icon>

                </div>

                <div class="la-card-footer-date">
                    {{ appointmentInfo.appointment.startDateTime | date: dateConstants.Formats.AngularPipeShortDateSlash
                    }}
                </div>

                <div class="la-card-footer-time">
                    {{ appointmentInfo.appointment.startDateTime | timePeriodLabel :
                    appointmentInfo.appointment.endDateTime
                    }}
                </div>

            </div>

            <div class="la-card-footer-status-wrap">

                @if (appointmentInfo.statusDetails.isConfirmed || appointmentInfo.statusDetails.isPending) {
                <div class="la-card-footer-status"
                    [class.la-card-footer-status--confirmed]="appointmentInfo.statusDetails.isConfirmed">

                    <rpc-icon class="la-card-footer-status-icon"
                        [iconName]="appointmentInfo.statusDetails.isConfirmed ? 'check' : 'clock'">
                    </rpc-icon>

                    <div class="la-card-footer-status-text">
                        {{(appointmentInfo.statusDetails.isConfirmed
                        ? 'LANDING_APPOINTMENT_CARD.TITLES.CONFIRMED'
                        : 'LANDING_APPOINTMENT_CARD.TITLES.PENDING'
                        ) | translate}}
                    </div>

                </div>
                }

            </div>

        </div>

    </ng-template>

</gallery-listing-card>
}